export const INVALID_USER_LOGIN = "INVALID_USER_LOGIN";
export const ACCOUNT_ALREADY_LOGIN = "ACCOUNT_ALREADY_LOGIN";
export const USER_BLOCKED = "USER_BLOCKED";
export const NO_ROLE_ACCESS = "NO_ROLE_ACCESS";
export const UNAUTHORIZED = "UNAUTHORIZED";
export const INVALID_OTP = "INVALID_OTP";
export const PRODUCT_CATEGORY_ADD_INVALID_INPUT = "INVALID_INPUT";
export const EXCEED_OTP_LIMIT = "EXCEED_OTP_LIMIT";
export const INVALID_RESET_PASSWORD_CODE = "INVALID_RESET_PASSWORD_CODE";
export const USER_NOT_FOUND = "USER_NOT_FOUND";
export const BAD_REQUEST = "BAD_REQUEST";
export const EMAIL_UNIQUE = "EMAIL_UNIQUE";
export const EMPLOYEE_ID_UNIQUE = "EMPLOYEE_ID_UNIQUE";
export const GLOBAL_ID_UNIQUE = "GLOBAL_ID_UNIQUE";
export const OTHER_EMAIL_UNIQUE = "OTHER_EMAIL_UNIQUE";
export const REQUIRED_PRODUCT_CATEGORY = "REQUIRED_PRODUCT_CATEGORY";
export const NO_QUESTIONNAIRE = "NO_QUESTIONNAIRE";
export const OPERATIONAL_PRIMARY = "OPERATIONAL_PRIMARY";
export const QUESTIONNAIRE_NOT_EVALUATED = "QUESTIONNAIRE_NOT_EVALUATED";
export const AUDIT_LINK_TOKEN_EXPIRE = "AUDIT_LINK_TOKEN_EXPIRE";
export const AUDIT_ON_HOLD = "AUDIT_ON_HOLD";
export const NO_QUESTIONNAIRE_ASSIGNED = "NO_QUESTIONNAIRE_ASSIGNED";
export const AUDIT_MEDIUM_NOT_MATCH = "AUDIT_MEDIUM_NOT_MATCH";
export const NO_DATA_FOUND = "NO_DATA_FOUND";
export const NO_PARTICIPANT_FOUND = "NO_PARTICIPANT_FOUND";
export const UNIQUE_DATA_REQUIRE = "UNIQUE_DATA_REQUIRE";
export const AUDIT_IN_PROGRESS = "AUDIT_IN_PROGRESS"
export const WEAK_PASSWORD = "WEAK_PASSWORD"
